module.exports = __webpack_public_path__ + "static/media/covid.ce09ee71.jpg";